module.exports = __webpack_public_path__ + "static/img/icon_swiper_ysaq_tab.dfca8ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_swiper_ysaq_tab.png
// module id = nSYC
// module chunks = 1